/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import firebase from 'gatsby-plugin-firebase';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import '../../static/fonts.scss';
import CookieBtn from '@components/CookieBtn/CookieBtn';
// Providers & Contexts
import { GlobalProvider } from '@context/GlobalContext';
import { ModalContextProvider } from '@context/modal';
import '../styles/global.scss';
import Announcement from '@components/Announcement';
import TrackingProvider from '../context/TrackingProvider';

const Layout = ({ children }) => {
    function get_in_local_storage(key) {
        if (typeof window !== 'undefined') {
            return localStorage.getItem(key);
        } else {
            return false;
        }
    }

    useEffect(() => {
        firebase.analytics().logEvent('general_page_view');
    }, []);

    return (
        <TrackingProvider>
            <GlobalProvider>
                <ModalContextProvider>
                    <div>
                        {/* <Announcement /> */}
                        <main>{children}</main>
                        {get_in_local_storage('cookie_accepted') !== 'true' ? (
                            <CookieBtn />
                        ) : (
                            ''
                        )}
                    </div>
                </ModalContextProvider>
            </GlobalProvider>
        </TrackingProvider>

    );
};

Layout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Layout;
